import React from 'react';

import { useFormContext } from 'react-hook-form';

import { IAssigneeOptionsList } from 'hooks/useAssigneeOptionsList';

import { TabOptions } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter.utils';
import { HasCommentsFilter } from 'components/common/CustomFilters/HasCommentsFilter/hasCommentsFilter';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import {
    getInputValueForHasComments,
    hasCommentFixedDateMenuOptions,
    hasCommentsTodayMenuOptions,
    hasCommentsVersionDateMenuOptions,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.utils';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const HasComments = ({ isSelected, onFiltersChanged }) => {
    const { watch } = useFormContext<IFields>();
    const handleHasCommentsDate = (data: {
        value?: string[] | string;
        type?: TabOptions;
        commenter: IAssigneeOptionsList | null;
        mentioned: IAssigneeOptionsList | null;
    }) => {
        if (data.type === 'FIXED_DATE') {
            const tempFlags = watch('flags');
            delete tempFlags.commentRange;
            onFiltersChanged({
                hasComments: {
                    value: Array.isArray(data.value) ? data.value.map(String) : [],
                    type: data.type,
                },
                flags: tempFlags,
            });
        } else {
            onFiltersChanged({
                hasComments: { value: [], type: data.type },
                flags: {
                    ...watch('flags'),
                    commentRange: data.value as string,
                },
            });
        }

        onFiltersChanged({
            commenter: data.commenter,
            mentioned: data.mentioned,
        });
    };

    const hasCommentsExistingData = {
        type: watch('hasComments').type,
        value: watch('hasComments').value.length === 0 ? watch('flags').commentRange : watch('hasComments').value,
        commenter: watch('commenter'),
        mentioned: watch('mentioned'),
    };
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Has Comments</span>
            <HasCommentsFilter
                onChange={handleHasCommentsDate}
                value={hasCommentsExistingData}
                inputDefaultValue={getInputValueForHasComments(hasCommentsExistingData)}
                fixedDateMenuOptions={hasCommentFixedDateMenuOptions}
                todayMenuOptions={hasCommentsTodayMenuOptions}
                versionDateMenuOptions={hasCommentsVersionDateMenuOptions}
                watch={watch}
            />
        </div>
    ) : null;
};
